import * as React from "react";
import { FieldPickerField } from "../components/field-picker/components/fields/fields.types";

export const useFieldsController = () => {
  const [selectedFieldsInFieldPicker, setSelectedFieldsInFieldPicker] = React.useState<Array<FieldPickerField>>([]);

  const handleSelectedFieldsInFieldPickerChange = React.useCallback((fields: Array<FieldPickerField>) => {
    setSelectedFieldsInFieldPicker(fields);
  }, []);

  return {
    selectedFieldsInFieldPicker,
    handleSelectedFieldsInFieldPickerChange,
  };
};
